import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DataViewModule } from 'primeng/dataview';
import { Tag } from 'primeng/tag';

import { DataviewConfig, DataviewRowInterface } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-dataview-component',
  standalone: true,
  imports: [
    DataViewModule,
    Tag,
  ],
  templateUrl: './dataview-component.html',
  styleUrl: './dataview-component.css',
})
export class DataviewComponent {
  @Input()
  public config!: DataviewConfig<any>;

  @Input()
  public rows: DataviewRowInterface<any>[] = [];

  public canScrollUp: boolean = false;
  public canScrollDown: boolean = false;

  constructor(
    private _domSanitizer: DomSanitizer
  ) {}

  public onScroll(event: Event): void {
    const element = event.target as HTMLElement;

    this.canScrollUp = element.scrollTop > 5;
    this.canScrollDown =
      element.scrollTop < element.scrollHeight - element.clientHeight - 5;
  }

  public byPass(s: string): SafeHtml {
    return this._domSanitizer.bypassSecurityTrustHtml(s);
  }

  public onItemClick(item: DataviewRowInterface<any>): void {
    if (this.config.rowAction) {
      this.config.rowAction(item.row);
    }
  }
}